module.exports = __webpack_public_path__ + "static/media/header-network-bsc.00f6f1fd.svg";